import React, { useState, useEffect } from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogTitle, 
  DialogActions,
  Button, 
  Typography, 
  LinearProgress,
  Stack,
  Box
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const PasswordExpiredModal = () => {
  const [show, setShow] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [redirectUrl, setRedirectUrl] = useState('/auth/reset-password');

  useEffect(() => {
    const handleExpiration = (event) => {
      const data = event.detail;
      setRedirectUrl(data.redirect_to || '/auth/reset-password');
      setCountdown(data.grace_period_seconds || 5);
      setShow(true);
    };

    window.addEventListener('auth:password_expired', handleExpiration);

    return () => {
      window.removeEventListener('auth:password_expired', handleExpiration);
    };
  }, []);

  useEffect(() => {
    let timer;
    if (show && countdown > 0) {
      timer = setTimeout(() => setCountdown(c => c - 1), 1000);
    } else if (show && countdown === 0) {
      window.location.href = redirectUrl;
    }
    return () => clearTimeout(timer);
  }, [show, countdown, redirectUrl]);

  const progress = (countdown / 5) * 100;

  if (!show) return null;

  return (
    <Dialog 
      open={show}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      slotProps={{
        paper: { sx: { borderRadius: 2 } }
      }}
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <LockIcon color="error" />
          <Typography variant="h6" component="div" color="error">
            Password Scaduta
          </Typography>
        </Stack>
      </DialogTitle>
      
      <DialogContent dividers>
        <Typography paragraph>
          Per motivi di sicurezza, devi aggiornare la tua password.
        </Typography>
        
        <Box sx={{ mt: 3, mb: 2 }}>
          <Typography variant="body2" color="text.secondary" align="center">
            Verrai reindirizzato tra{' '}
            <Typography 
              component="span" 
              variant="h4" 
              color="primary"
              sx={{ fontWeight: 'bold' }}
            >
              {countdown}
            </Typography>
            {' '}secondi...
          </Typography>
          <LinearProgress 
            variant="determinate" 
            value={progress} 
            sx={{ mt: 2, height: 8, borderRadius: 1 }} 
          />
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={() => window.location.href = redirectUrl}
          variant="contained"
          color="primary"
          fullWidth
          size="large"
        >
          Vai subito al reset password
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordExpiredModal;